import { render } from "./OnboardingForm.vue?vue&type=template&id=79b5f356&scoped=true"
import script from "./OnboardingForm.vue?vue&type=script&lang=js"
export * from "./OnboardingForm.vue?vue&type=script&lang=js"

import "./OnboardingForm.vue?vue&type=style&index=0&id=79b5f356&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b5f356"]])

export default __exports__